import { gql } from '@apollo/client';

/** TMS 任务报表专用：批量获取报表下载 URLs（7 天有效） */
export const GET_TMS_BATCH_REPORT_DOWNLOAD_URLS = gql`
  query ReportQuery($reportIds: [Long!]!, $warehouseId: Long!) {
    getTmsBatchReportDownloadUrls(reportIds: $reportIds, warehouseId: $warehouseId)
  }
`;

export interface GetTmsBatchReportDownloadUrlsResponse {
  getTmsBatchReportDownloadUrls: string[];
}

export interface GetTmsBatchReportDownloadUrlsVariables {
  reportIds: number[];
  warehouseId: number;
}
